export const drillDownViewData = {
    inventoryAuditView: {
        title: 'inventory.audit.title',
        actions: [
            {
                label: 'inventory.audit.action.initialize',
                action: 'initialize',
                entity: 'inventoryLedger',
                id: 'all',
                confirm: true,
                modalConfig: 'confirmInitializeLedger',
                onComplete: 'refresh',
                successMessage: 'inventory.audit.initialize.success'
            }
        ],
        source: {
            entity: 'inventoryLedger',
            action: 'audit',
            id: 'all',
            rowsPath: 'data.all'
        },
        level0: {
            keyFields: ['itemId'],
            preserveFields: ['itemName'],
            aggregate: {
                aggregateQuantity: 'sum',
                ledgerSum: 'sum',
                variance: 'sum',
                inSync: 'every'
            },
            statusField: 'inSync',
            statusMap: { true: 'ok', false: 'error' },
            columns: [
                { id: 'itemName',          label: 'inventory.audit.table.item',      width: '200px' },
                { id: 'aggregateQuantity', label: 'inventory.audit.table.quantity',  width: '100px', type: 'number' },
                { id: 'ledgerSum',         label: 'inventory.audit.table.ledgerSum', width: '100px', type: 'number' },
                { id: 'variance',          label: 'inventory.audit.table.variance',  width: '100px', type: 'amount' }
            ],
            mobile: {
                left: {
                    tag:     { field: 'itemName' }
                },
                right: {
                    tag:    { field: 'aggregateQuantity' },
                    subTag: { field: 'variance' }
                }
            }
        },
        level1: {
            keyFields: ['itemId', 'locationId'],
            statusField: 'inSync',
            statusMap: { true: 'ok', false: 'error' },
            columns: [
                { id: 'itemName',          label: 'inventory.audit.table.item',      width: '200px' },
                { id: 'locationId',        label: 'inventory.audit.table.location',  width: '150px' },
                { id: 'aggregateQuantity', label: 'inventory.audit.table.quantity',  width: '100px', type: 'number' },
                { id: 'ledgerSum',         label: 'inventory.audit.table.ledgerSum', width: '100px', type: 'number' },
                { id: 'variance',          label: 'inventory.audit.table.variance',  width: '100px', type: 'amount' }
            ],
            mobile: {
                left: {
                    tag:     { field: 'locationId' }
                },
                right: {
                    tag:    { field: 'aggregateQuantity' },
                    subTag: { field: 'variance' }
                }
            }
        },
        level2: {
            action: 'reconcile',
            entity: 'inventoryLedger',
            idField: 'itemId',
            paramsFromRow: { locationId: 'locationId' },
            rowsPath: 'data.locations[0].entries',
            entityRoutes: {
                stockReceipt:    '/inventory/receipt',
                stockAdjustment: '/inventory/adjustment',
                stockMovement:   '/inventory/movement',
                stockShipment:   '/inventory/shipment'
            },
            columns: [
                { id: 'date',           label: 'inventory.audit.detail.date',     width: '110px', type: 'date' },
                { id: 'type',           label: 'inventory.audit.detail.type',     width: '120px' },
                { id: 'delta',          label: 'inventory.audit.detail.delta',    width: '100px', type: 'amount' },
                {
                    id: 'documentNumber',
                    label: 'inventory.audit.detail.document',
                    width: '150px',
                    type: 'entityLink',
                    idField: 'documentId',
                    entityField: 'documentEntity'
                }
            ],
            mobile: {
                left: {
                    tag:     { field: 'documentNumber' },
                    subTag:  { field: 'type' }
                },
                right: {
                    tag:    { field: 'delta' },
                    subTag: { field: 'date' }
                }
            }
        }
    }
}

export default drillDownViewData
